// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"drp","svgDefs":"drq","canvas":"drr"};